import { render, staticRenderFns } from "./MyProfileCompetition.vue?vue&type=template&id=637f4dae&scoped=true"
import script from "./MyProfileCompetition.vue?vue&type=script&lang=js"
export * from "./MyProfileCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f4dae",
  null
  
)

export default component.exports